@if (featureEnabled) {
  <div class="widget-container">
    <button (click)="launchCore()" color="primary" mat-flat-button>
      <img src="assets/urm_main_logo.svg" alt="Core" style="height: 16px; margin-left: 4px;margin-top: -2px; vertical-align: middle;">
      Core
    </button>
  </div>
}
